export default __webpack_public_path__ + "static/media/80t.9d9e8229.jpg";